import gql from 'graphql-tag';
export const changeSignMail = gql`
mutation changeSignMail($input: String) {
  changeSignMail(newSignMail: $input)
}
`;
